import React from "react"
import { Header, Container, Segment, Grid, Modal, Button, Icon} from "semantic-ui-react"
import { observer } from "mobx-react"
import categoryStore from "stores/categoryStore"
import settingStore from "stores/settingStore"
import swal from "sweetalert2"
import "sweetalert2/dist/sweetalert2.min.css"
import shop from "shop/shop"
import $fetch from "sdk/$fetch";
import htmr                                                                           from "htmr";

@observer
class CategoryList extends React.Component {

  render() {
    const { categories } = categoryStore
    return <div>
      {categories.map( category => {
        return <div key={category.map_id}>{category.title}</div>
      } )}
    </div>
  }
}

export default class SofortOrderPage extends React.Component {

  state = {
    modalOpen: false,
    oldMode: settingStore.get("orderMode"),
    mode: settingStore.get("orderMode"),
  }

setStoreMode = (e, mode) => {
  const oldMode = settingStore.get("orderMode")

  if (oldMode && mode !== oldMode) {
    swal.fire({
      icon: "question",
      title: translate("Wechsel bestätigen"),
      text: translate("confirm_change"),
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: translate("Weiter"),
      cancelButtonText: translate("Zurück"),
      customClass: {
        popup: "rounded-2xl shadow-lg p-6",
        title: "text-gray-800 font-semibold text-lg",
        confirmButton: "bg-green-600 hover:bg-green-700 text-white rounded-full px-5 py-2",
        cancelButton: "bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-full px-5 py-2",
      },
      buttonsStyling: false, // wichtig, damit Tailwind greift
    }).then((result) => {
      if (result.isConfirmed) {
        shop.cart.clear()
        this.continue(mode)
      }
    })
  } else {
    this.continue(mode)
  }
}

  continue( mode ) {
    $fetch.clear()
    settingStore.set( "orderMode", mode )
    categoryStore.updateCategories()
    if ( mode === "MODE_PREORDER" ) {
      shop.cart.setExtra( "preorder", true )
    } else {
      shop.cart.setExtra( "preorder", false )
    }
    this.props.history.replace( "/" )
  }

  render() {
    const { modalOpen, oldMode, mode } = this.state

    const confirmChange = () => {
      shop.cart.clear()
      this.continue(this.state.pendingMode)
      this.setState({ modalOpen: false, pendingMode: null })

      $fetch.clear()
      settingStore.set( "orderMode", mode )
      categoryStore.updateCategories()
      if ( mode === "MODE_PREORDER" ) {
        shop.cart.setExtra( "preorder", true )
      } else {
        shop.cart.setExtra( "preorder", false )
      }
      this.props.history.replace( "/" )
    }
    return <div className="bg-silver min-vh-100">
      <div className="flex flex-column justify-center min-vh-100 backgroundSofortOrderPage">
        <div className="backgroundSofortOrderPageOverlay">
       <Modal
        open={modalOpen}
        onClose={() => this.setState({ modalOpen: false })}
        size="small"
        closeIcon
      >
        <Modal.Header style={{minHeight: "100px"}}>
          <Icon className="red large warning circle"></Icon>
          <p className="tc f2 fw6 black-70 ">{translate("Achtung")}</p>
        </Modal.Header>

        <Modal.Content style={{minHeight: "100px"}}>
          <p className="tc f3 fw6 black-70">{htmr(translate("confirm_change"))}</p>
        </Modal.Content>

        <Modal.Actions style={{minHeight: "100px"}} className="flex flex-row justify-between">
          <Button
            onClick={() => this.setState({ modalOpen: false })}
            content={("Zurück")}
            icon="arrow left"
            basic
            style={{borderRadius:"35px", width: "250px", height: "50px"}}
          />
          <Button
            style={{borderRadius:"35px", width: "250px", height: "50px"}} primary
            onClick={confirmChange}
            content={("Weiter")}
            icon="check"
          />
        </Modal.Actions>
      </Modal>
        <Container text className={"pt4"}>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column>
                <Segment className={"tc"} style={{borderRadius: "25px", minHeight: "150px"}}>
                  <Header as={"h3"}>{translate( "MODE_AVAILABLE" )}</Header>
                  <div className={"pb3"}>
                    {translate("sofort_notice")}
                  </div>
                </Segment>
                <div className="tc"><Button onClick={() => {if(oldMode === "MODE_AVAILABLE") {
                      this.props.history.replace( "/" )
                    }
                   this.setState({modalOpen: oldMode === "MODE_AVAILABLE" ? false : true, mode: "MODE_AVAILABLE"})}} 
                   style={{borderRadius:"35px", width: "250px", height: "50px"}} primary>{translate("Weiter")}</Button></div>
              </Grid.Column>
              <Grid.Column >
                <Segment className={"tc"} style={{borderRadius: "25px", minHeight: "150px"}}>
                  <Header as={"h3"}>{translate( "MODE_PREORDER" )}</Header>
                  <div className={"pb3"}>
                    <p>{translate("preorder_notice")}</p>
                  </div>
                </Segment>
                <div className="tc"><Button onClick={() => {if(oldMode === "MODE_PREORDER") {
                  this.props.history.replace( "/" )
                }
                this.setState({modalOpen: oldMode === "MODE_PREORDER" ? false : true, mode: "MODE_PREORDER"})}} 
                style={{borderRadius:"35px", width: "250px", height: "50px"}} primary>{translate("Weiter")}</Button></div> {/*( e ) => this.setStoreMode( e, "MODE_PREORDER" ) */}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
        </div>
      </div>
    </div>
  }
}



// WEBPACK FOOTER //
// ./src/theme/lucht-test/pages/SofortOrderPage.js